(() => {
  function setCookie(name, value) {
    const expires = new Date(Date.now() + 86400000).toUTCString();
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    }
    return null;
  }

  function isMobileAppWrapper() {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes("FashionphileApp");
  }

  function getMobileAppVersion() {
    const version = (navigator.userAgent.match(/VersionName-([^;]+);/) || [])[1];
    return version;
  }

  function silentlySsoLoginShopify(clerkUserId) {
    let currentPath = window.location.pathname + window.location.search;
    if (currentPath.includes("sso=silent")) {
      const message = "Sync mismatch Shopify and Clerk (Signed in), url already has sso=silent";
      Sentry?.withScope?.((scope) => {
        scope.setContext("Clerk", {
          clerkUserId: String(clerkUserId),
          status: String(Clerk?.status),
          client: String(Clerk?.client?.id),
        });
        scope.setUser({ id: String(clerkUserId) });
        Sentry?.captureMessage?.(message, "error");
      });
      return;
    }
    const separator = currentPath.includes("?") ? "&" : "?";
    const redirectUrl = `${currentPath}${separator}sso=silent`;

    const message = "Sync mismatch Shopify and Clerk (Signed in), Shopify sso signed in";
    Sentry?.withScope?.((scope) => {
      scope.setContext("Clerk", {
        clerkUserId: String(clerkUserId),
        status: String(Clerk?.status),
        client: String(Clerk?.client?.id),
      });
      scope.setUser({ id: String(clerkUserId) });
      Sentry?.captureMessage?.(message, "error");
    });

    setCookie("syncShopifySsoCount", 1, 1);
    window.location.href = redirectUrl;
  }

  function silentlyLogoutForLoginShopify(baseLogoutUrl, clerkUserId) {
    const currentPath = window.location.pathname + window.location.search;
    const encodedReturnUrl = encodeURIComponent(currentPath);
    const redirectUrl = `${baseLogoutUrl}?return_url=${encodedReturnUrl}`;

    const message = "Sync mismatch Shopify and Clerk (Signed in), Shopify silently signed out for sign in";
    Sentry?.withScope?.((scope) => {
      scope.setContext("Clerk", {
        clerkUserId: String(clerkUserId),
        status: String(Clerk?.status),
        client: String(Clerk?.client?.id),
      });
      scope.setUser({ id: String(clerkUserId) });
      Sentry?.captureMessage?.(message, "error");
    });
    setCookie("syncShopifyLogoutForLoginCount", 1, 1);
    window.location.href = redirectUrl;
  }

  function silentlyAuthenticationLoginShopify(baseLoginUrl, clerkUserId) {
    let currentPath = window.location.pathname + window.location.search;
    if (!currentPath.includes("sso=silent")) {
      const separator = currentPath.includes("?") ? "&" : "?";
      currentPath += `${separator}sso=silent`;
    }
    const encodedReturnTo = encodeURIComponent(currentPath);
    const redirectUrl = `${baseLoginUrl}?return_to=${encodedReturnTo}`;

    const message = "Sync mismatch Shopify and Clerk (Signed in), Shopify authentication signed in";
    Sentry?.withScope?.((scope) => {
      scope.setContext("Clerk", {
        clerkUserId: String(clerkUserId),
        status: String(Clerk?.status),
        client: String(Clerk?.client?.id),
      });
      scope.setUser({ id: String(clerkUserId) });
      Sentry?.captureMessage?.(message, "error");
    });

    setCookie("syncShopifyAuthenticationCount", 1, 1);
    window.location.href = redirectUrl;
  }

  async function silentlyLogoutClerk(webAppApiUrl, clerkUserId, syncShopifyClerkLogoutCount) {
    // Collecting data before implementing this clerk logout.
    // const token = await window.getSessionToken();
    // if (token) {
    //   await fetch(`${webAppApiUrl}/auth/revoke-client-session`, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //     },
    //     body: JSON.stringify({ session_id: Clerk?.session?.id }),
    //   });
    //   window.flutter_inappwebview?.callHandler("authentication", { action: "clerk-silently-logged-out" });
    // }
    const message = "Sync mismatch Shopify and Clerk (Signed in), Clerk silently signed out";
    Sentry?.withScope?.((scope) => {
      scope.setContext("Clerk", {
        clerkUserId: String(clerkUserId),
        status: String(Clerk?.status),
        client: String(Clerk?.client?.id),
        syncShopifyClerkLogoutCount: syncShopifyClerkLogoutCount + 1,
      });
      scope.setUser({ id: String(clerkUserId) });
      Sentry?.captureMessage?.(message, "error");
    });
    setCookie("syncShopifyClerkLogoutCount", syncShopifyClerkLogoutCount + 1, 1);
  }

  function silentlyLogoutShopify(baseLogoutUrl, customerId) {
    const currentPath = window.location.pathname + window.location.search;
    const encodedReturnUrl = encodeURIComponent(currentPath);
    const redirectUrl = `${baseLogoutUrl}?return_url=${encodedReturnUrl}`;

    const message = "Sync mismatch Shopify (Signed in) and Clerk, Shopify silently signed out";
    Sentry?.withScope?.((scope) => {
      scope.setContext("Clerk", {
        customerId: String(customerId),
        status: String(Clerk?.status),
        session: String(Clerk?.session),
        isSignedIn: String(Clerk?.isSignedIn),
        client: String(Clerk?.client?.id),
      });
      scope.setUser({ id: String(customerId) });
      Sentry?.captureMessage?.(message, "error");
    });
    setCookie("syncShopifyLogoutCount", 1, 1);
    window.location.href = redirectUrl;
  }

  async function syncSignIn(customerId, clerkUserId, baseLoginUrl, baseLogoutUrl, webAppApiUrl) {
    if (!!customerId !== !!clerkUserId) {
      if (clerkUserId) {
        const syncShopifySsoCount = parseInt(getCookie("syncShopifySsoCount") || "0", 10);
        if (!syncShopifySsoCount) {
          silentlySsoLoginShopify(clerkUserId);
        } else {
          const syncShopifyLogoutForLoginCount = parseInt(getCookie("syncShopifyLogoutForLoginCount") || "0", 10);
          if (!syncShopifyLogoutForLoginCount) {
            silentlyLogoutForLoginShopify(baseLogoutUrl, clerkUserId);
          } else {
            const syncShopifyAuthenticationCount = parseInt(getCookie("syncShopifyAuthenticationCount") || "0", 10);
            if (!syncShopifyAuthenticationCount) {
              silentlyAuthenticationLoginShopify(baseLoginUrl, clerkUserId);
            } else {
              const syncShopifyClerkLogoutCount = parseInt(getCookie("syncShopifyClerkLogoutCount") || "0", 10);
              if (!syncShopifyClerkLogoutCount) {
                setCookie("syncShopifyClerkLogoutCount", 1, 1);
                const message = "Sync mismatch Shopify and Clerk (Signed in), 1 recovery wait";
                Sentry?.withScope?.((scope) => {
                  scope.setContext("Clerk", {
                    clerkUserId: String(clerkUserId),
                    status: String(Clerk?.status),
                    client: String(Clerk?.client?.id),
                    syncShopifyClerkLogoutCount: syncShopifyClerkLogoutCount + 1,
                  });
                  scope.setUser({ id: String(clerkUserId) });
                  Sentry?.captureMessage?.(message, "error");
                });
              } else if (syncShopifyClerkLogoutCount <= 1) {
                await silentlyLogoutClerk(webAppApiUrl, clerkUserId, syncShopifyClerkLogoutCount);
              } else {
                setCookie("syncShopifyClerkLogoutCount", syncShopifyClerkLogoutCount + 1, 1);
                const message = "Sync mismatch Shopify and Clerk (Signed in), Clerk recently signed out";
                Sentry?.withScope?.((scope) => {
                  scope.setContext("Clerk", {
                    clerkUserId: String(clerkUserId),
                    status: String(Clerk?.status),
                    client: String(Clerk?.client?.id),
                    syncShopifyClerkLogoutCount: syncShopifyClerkLogoutCount + 1,
                  });
                  scope.setUser({ id: String(clerkUserId) });
                  Sentry?.captureMessage?.(message, "error");
                });
              }
            }
          }
        }
      } else if (isMobileAppWrapper()) {
        const message = "Sync mismatch Shopify (Signed in) and Clerk (mobile app wrapper), no action taken";
        const appVersion = getMobileAppVersion();
        Sentry?.withScope?.((scope) => {
          scope.setContext("Clerk", {
            customerId: String(customerId),
            status: String(Clerk?.status),
            session: String(Clerk?.session),
            isSignedIn: String(Clerk?.isSignedIn),
            client: String(Clerk?.client?.id),
          });
          scope.setTag("appVersion", String(appVersion));
          scope.setUser({ id: String(customerId) });
          Sentry?.captureMessage?.(message, "error");
        });
        window.flutter_inappwebview?.callHandler("authentication", {
          action: "sync-mismatch-shopify-signed-in",
          customerId,
        });
      } else {
        const syncShopifyLogoutCount = parseInt(getCookie("syncShopifyLogoutCount") || "0", 10);
        if (!syncShopifyLogoutCount) {
          silentlyLogoutShopify(baseLogoutUrl, customerId);
        } else {
          setCookie("syncShopifyLogoutCount", syncShopifyLogoutCount + 1, 1);
          const message = "Sync mismatch Shopify (Signed in) and Clerk, Shopify recently signed out";
          Sentry?.withScope?.((scope) => {
            scope.setContext("Clerk", {
              customerId: String(customerId),
              status: String(Clerk?.status),
              session: String(Clerk?.session),
              isSignedIn: String(Clerk?.isSignedIn),
              client: String(Clerk?.client?.id),
              syncShopifyLogoutCount: syncShopifyLogoutCount + 1,
            });
            scope.setUser({ id: String(customerId) });
            Sentry?.captureMessage?.(message, "error");
          });
        }
      }
    }
  }

  window.syncSignIn = syncSignIn;
})();
